import axiosFlow from '@/services/axios/axiosFlow'

export default class ChatBotService {
  static async get() {
    return axiosFlow.get(`chat-bots?ItensPorPagina=${100}`).then(res => res.data.data.items)
  }

  static async getById(chatBotId) {
    return axiosFlow.get(`chat-bots/${chatBotId}`).then(res => res.data.data)
  }

  static async getArvoresDisponiveis(chatBotId) {
    return axiosFlow.get(`chat-bots/${chatBotId}/arvores`).then(res => res.data.data)
  }

  static async getArvoreNos(chatBotId, arvoreId) {
    return axiosFlow.get(`chat-bots/${chatBotId}/arvores/${arvoreId}/nos`).then(res => res.data.data)
  }

  static async getConfigWhatsApp(chatBotId) {
    return axiosFlow.get(`chat-bots/${chatBotId}/configs/whatsapp`).then(res => res.data.data)
  }

  static async getConfigWhatsAppTemplates(chatBotId) {
    return axiosFlow.get(`chat-bots/${chatBotId}/configs/whatsapp/templates`).then(res => res.data.data)
  }

  static async getConfigMessenger(chatBotId) {
    return axiosFlow.get(`chat-bots/${chatBotId}/configs/meta/messenger`).then(res => res.data.data)
  }

  static async criar(body) {
    return axiosFlow.post('chat-bots', body).then(res => res.data.data.id)
  }

  static async atualizar(chatBotId, body) {
    return axiosFlow.put(`chat-bots/${chatBotId}`, body).then(res => res.data.data)
  }

  static async atualizarStatus(chatBotId, body) {
    return axiosFlow.put(`chat-bots/${chatBotId}/status`, body)
  }

  static async criarArvore(chatBotId, body) {
    return axiosFlow.post(`chat-bots/${chatBotId}/arvores`, body).then(res => res.data.data.id)
  }

  static async atualizarArvore(chatBotId, arvoreId, body) {
    return axiosFlow.put(`chat-bots/${chatBotId}/arvores/${arvoreId}`, body)
  }

  static async deletarArvore(chatBotId, arvoreId) {
    return axiosFlow.delete(`chat-bots/${chatBotId}/arvores/${arvoreId}`)
  }

  static async criarArvoreNo(chatBotId, arvoreId, body) {
    return axiosFlow.post(`chat-bots/${chatBotId}/arvores/${arvoreId}/nos`, body)
  }

  static async atualizarArvoreNo(chatBotId, arvoreId, noId, body) {
    return axiosFlow.put(`chat-bots/${chatBotId}/arvores/${arvoreId}/nos/${noId}`, body)
  }

  static async deletarArvoreNo(chatBotId, arvoreId, noId) {
    return axiosFlow.delete(`chat-bots/${chatBotId}/arvores/${arvoreId}/nos/${noId}`)
  }

  static async criarArvoreNoPesquisaNota(chatBotId, arvoreId, body) {
    return axiosFlow.post(`chat-bots/${chatBotId}/arvores/${arvoreId}/nos/pesquisa-nota`, body)
  }

  static async atualizarArvoreNoPesquisaNota(chatBotId, arvoreId, noId, body) {
    return axiosFlow.put(`chat-bots/${chatBotId}/arvores/${arvoreId}/nos/${noId}/pesquisa-nota`, body)
  }

  static async criarTemplate(chatBotId, body) {
    return axiosFlow.post(`chat-bots/${chatBotId}/configs/whatsapp/templates`, body)
  }

  static async atualizarTemplate(chatBotId, templateId, body) {
    return axiosFlow.put(`chat-bots/${chatBotId}/configs/whatsapp/templates/${templateId}`, body)
  }

  static async updateConfigWhatsApp(chatBotId, body) {
    return axiosFlow.put(`chat-bots/${chatBotId}/configs/whatsapp`, body)
  }

  static async deleteChatBotConfigWhatsApp(chatBotId) {
    return axiosFlow.delete(`chat-bots/${chatBotId}/configs/whatsapp`)
  }

  static async updateConfigMessenger(chatBotId, body) {
    return axiosFlow.put(`chat-bots/${chatBotId}/configs/meta/messenger`, body)
  }

  static async deleteConfigMessenger(chatBotId) {
    return axiosFlow.delete(`chat-bots/${chatBotId}/configs/meta/messenger`)
  }
}
